import React, { FunctionComponent } from "react";

const DownloadCertificate: FunctionComponent = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <polygon points="102.4,0 102.4,25.6 435.2,25.6 435.2,409.6 460.8,409.6 460.8,0 		" />
        </g>
      </g>
      <g>
        <g>
          <rect x="153.6" y="128" width="153.6" height="25.6" />
        </g>
      </g>
      <g>
        <g>
          <rect x="102.4" y="179.2" width="256" height="25.6" />
        </g>
      </g>
      <g>
        <g>
          <rect x="102.4" y="230.4" width="179.2" height="25.6" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M384,51.2H76.8H51.2v25.6v358.4v25.6h25.6h153.6v25.6c0,8.875,4.591,17.109,12.143,21.777
			C246.647,510.72,251.324,512,256,512c3.908,0,7.834-0.896,11.443-2.705l14.157-7.074l14.148,7.074
			c3.618,1.809,7.535,2.705,11.452,2.705c4.685,0,9.353-1.28,13.457-3.823c7.552-4.668,12.143-12.902,12.143-21.777v-25.6H384h25.6
			v-25.6V76.8V51.2H384z M307.2,486.4l-25.6-12.8L256,486.4v-30.319c8.047,2.867,16.58,4.719,25.6,4.719
			c9.02,0,17.553-1.852,25.6-4.719V486.4z M281.6,435.2c-28.279,0-51.2-22.921-51.2-51.2c0-28.279,22.921-51.2,51.2-51.2
			c28.279,0,51.2,22.921,51.2,51.2C332.8,412.279,309.879,435.2,281.6,435.2z M384,435.2h-45.577
			c12.279-13.619,19.977-31.462,19.977-51.2c0-42.351-34.449-76.8-76.8-76.8s-76.8,34.449-76.8,76.8
			c0,19.738,7.697,37.581,19.977,51.2H76.8V76.8H384V435.2z"
          />
        </g>
      </g>
    </svg>
  );
};

export default DownloadCertificate;
